export class Widget {
    constructor(options = {}) {
        this.setEl(options.el || '');
    }
    setEl(el) {
        this.el = el;
        return this;
    }
    getEl() {
        return this.el;
    }
    getTemplate() {
        return this.template;
    }
    setTemplate(template) {
        this.template = template;
        return this;
    }
    setClient(client) {
        this.client = client;
        return this;
    }
    /**
     * Render the HTML and transform it into a HTML Node
     * @param {{}} options
     * @return {Node}
     */
    render(options = {}) {
        const template = this.getTemplate();
        return document.createRange().createContextualFragment(template);
    }
    executeJS() { }
    /**
     * Render and append the widgets into the right position
     * @param {{}} options
     */
    build(options = {}) {
        const elements = document.querySelectorAll(this.getEl());
        const domHtml = this.render(options);
        elements.forEach((element) => {
            element.innerHTML = '';
            element.appendChild(domHtml.cloneNode(true));
        });
        this.executeJS();
    }
}
